<!--  -->
<template>
  <div>
    <el-form ref="ruleForm" :model="ruleForm" :rules="rules" label-width="100px" class="demo-ruleForm">
      <el-form-item label="活动名称" prop="name">
        <el-input v-model="ruleForm.name" v-model.trim="ruleForm.name" style="width:300px" @input="ruleForm.name = ruleForm.name.replace(reg, '')" />
      </el-form-item>
      <!-- <el-form-item label="赠币金额" prop="coin">
        <el-input v-model="ruleForm.coin" style="width:300px" />
      </el-form-item> -->
      <el-form-item label="充值档位" prop="rechargeId">
        <el-select v-model="ruleForm.rechargeId" filterable placeholder="请选择" style="width:280px">
          <el-option
            v-for="item in chongarr"
            :key="item.config_id"
            :label="'充'+item.money+'      —— '+item.remark"
            :value="item.config_id"
          />
        </el-select>
      </el-form-item>
      <!-- <el-form-item label="领取名额" prop="limit_num">
        <el-input v-model="ruleForm.limit_num" style="width:300px" />
      </el-form-item> -->
      <el-form-item label="期限选择">
        <el-select v-model="time_type" :disabled="time_type===3" placeholder="请选择">
          <el-option
            v-for="item in timeoptions"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          />
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="submitForm('ruleForm')">立即创建</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import { readingservice, acawraccountlist } from '@/api/sourceMaterial.js'
export default {
  components: {},
  props: {
    platformid: {
      type: Number,
      default: null
    }
  },
  data() {
    var checkAger = (rule, value, callback) => {
      // eslint-disable-next-line eqeqeq
      if (this.ruleForm.appoint_day.length > 3) {
        callback(new Error('不能超过3位'))
      } else {
        callback()
      }
    }
    var checkAge = (rule, value, callback) => {
      console.log(this.ruleForm.timearr[0])
      console.log(this.ruleForm.timearr[1])
      // eslint-disable-next-line eqeqeq
      if (this.ruleForm.timearr[0] == this.ruleForm.timearr[1]) {
        callback(new Error('不能选择相同的时间'))
      } else {
        callback()
      }
    }
    return {
      // eslint-disable-next-line no-misleading-character-class
      reg: /[\uD83C|\uD83D|\uD83E][\uDC00-\uDFFF][\u200D|\uFE0F]|[\uD83C|\uD83D|\uD83E][\uDC00-\uDFFF]|[0-9|*|#]\uFE0F\u20E3|[0-9|#]\u20E3|[\u203C-\u3299]\uFE0F\u200D|[\u203C-\u3299]\uFE0F|[\u2122-\u2B55]|\u303D|[\A9|\AE]\u3030|\uA9|\uAE|\u3030/gi,
      ruleForm: {
        name: '',
        coin: '',
        limit_num: '',
        timearr: [],
        appoint_day: '',
        rechargeId: ''
      },
      timeoptions: [
        {
          value: 1,
          label: '指定期限'
        }, {
          value: 2,
          label: '固定天数'
        },
        {
          value: 3,
          label: '永久活动'
        }
      ],
      chongarr: [],
      time_type: 3,
      start_time: '',
      end_time: '',
      pickerOptions: { // 禁用当前日期之前的日期
        disabledDate(time) {
          // Date.now()是javascript中的内置函数，它返回自1970年1月1日00:00:00 UTC以来经过的毫秒数。
          return time.getTime() < Date.now() - 8.64e7
        }
      },
      rules: {
        name: [
          { required: true, message: '请输入活动名称', trigger: 'blur' }
        ],
        // coin: [
        //   { required: true, message: '请输入赠币金额', trigger: 'blur' }
        // ],
        rechargeId: [
          { required: true, message: '请输入充值档位', trigger: 'blur' }
        ],
        // limit_num: [
        //   { required: true, message: '请输入领取名额', trigger: 'change' }
        // ],
        timearr: [
          { type: 'array', required: true, message: '请选择时间', trigger: 'change' },
          { validator: checkAge, trigger: 'change' }
        ],
        appoint_day: [
          { required: true, message: '请输入固定天数', trigger: 'change' },
          { validator: checkAger, trigger: 'change' }
        ]
      }

    }
  },
  created() {
    this.getactivry()
  },
  mounted() {

  },
  methods: {
    datavalue(val) {
      console.log('val', val)
      this.start_time = val[0]
      this.end_time = val[1]
    },
    async getactivry() {
      // 获取主题
      const data = await acawraccountlist({
        platformId: this.platformid,
        activityType: 2
      })
      this.chongarr = data.data.programme.data
      console.log('data----------', data.data.programme.data)
      this.stylename = data.data.theme.type1[1].name
      this.styleid = data.data.theme.type1[1].id
      this.theme = [...data.data.theme.type1, ...data.data.theme.type2]
      for (let i = 0; i < data.data.resources.length; i++) {
        data.data.resources[i].title = `充${data.data.resources[i].money}得${data.data.resources[i].amount}书币+${data.data.resources[i].giftAmount}书币(赠)`
      }
      console.log(' this.chongarr :', this.chongarr)
    },
    submitForm(formName) {
      //  ['pop_range' + '[' + this.reding + ']']: this.reding
      this.$refs[formName].validate((valid) => {
        if (valid) {
          // const par = {}
          // if (this.time_type === 1) {
          //   par.time_type = this.time_type
          //   par.start_time = this.start_time
          //   par.end_time = this.end_time
          // } else {
          //   par.time_type = this.time_type
          //   par.appoint_day = Number(this.ruleForm.appoint_day)
          // }
          readingservice({
            activity_info: {
              name: this.ruleForm.name,
              rechargeId: this.ruleForm.rechargeId
              // coin: this.ruleForm.coin,
              // limit_num: this.ruleForm.limit_num
              // start_time: this.start_time,
              // end_time: this.end_time
            },
            platform_id: this.platformid,
            activity_type: 2,
            time_type: this.time_type
            // ...par
          }).then((res) => {
            this.$message({
              type: 'success',
              message: '添加成功!'
            })
            this.$emit('close')
          })
        } else {
          console.log('error submit!!')
          return false
        }
      })
    }
  }
}
</script>
<style scoped>
/* @import url(); 引入css类 */

</style>
